/// <reference path="../../../_Ext/Bases/GridBase.ts" />
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class QualityInspectionSelectGrid extends _Ext.GridBase<Administration.QualityInspectionTemplateRow, any> {
        protected getColumnsKey() { return 'Administration.QualityInspection'; }
        protected getDialogType() { return <any>Administration.QualityInspectionTemplateDialog; }
        protected getIdProperty() { return Administration.QualityInspectionTemplateRow.idProperty; }
        protected getLocalTextPrefix() { return Administration.QualityInspectionTemplateRow.localTextPrefix; }
        protected getService() { return Administration.QualityInspectionTemplateService.baseUrl; }
        //protected useViewMode() { return true; }
        //rowSelection: Serenity.GridRowSelectionMixin;
    
        constructor(container: JQuery, options) {
            super(container, options); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.slickGrid.setOptions({ rowHeight: 30 });

           
            return this;
        } 
        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady(); 
        }

        get selectedItems(): Administration.QualityInspectionTemplateRow[] {
            var _this = this;
            var selecteditems = this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            if (selecteditems.length != 1) {
                q.alert('', 'Only one template can be selected', true, 2999);
                return [];
            }
            return selecteditems;
        }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
             return true;
        }

    } 
}